export enum ChangeCabinetOptionsAction {
    UPDATE_BASKET_ITEM = 1,
    RETURN_CONFIGURATION = 2
}
